import type { FunctionComponent } from 'preact';

import type { TemplateFunction } from 'Components/types';
import { scrollToBase } from 'Core/actions/show';
import { useDispatch } from 'Core/store';

interface Params {
  scrollToTop: () => void;
}

export type { Params };

interface Props {
  template: TemplateFunction<Params>;
}

const ScrollController: FunctionComponent<Props> = ({ template }) => {
  const dispatch = useDispatch();
  const scrollToTop = () => dispatch(scrollToBase());
  return template.call({ scrollToTop });
};

export default ScrollController;
